/* Bramble — themascripts.
   Uitgangspunten: geen frameworks, alles progressive enhancement,
   custom elements zodat secties los herladen kunnen worden in de theme editor. */
(function () {
  'use strict';

  /* --- Hulpfuncties ---------------------------------------------------- */
  const on = (el, ev, fn, opt) => el && el.addEventListener(ev, fn, opt);
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const money = (cents, format) =>
    new Intl.NumberFormat('nl-NL', { style: 'currency', currency: format || 'EUR' })
      .format(cents / 100);

  const focusTrap = (container) => {
    const sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    return (e) => {
      if (e.key !== 'Tab') return;
      const items = $$(sel, container).filter((n) => n.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
  };

  /* --- Header: schaduw bij scroll -------------------------------------- */
  const header = $('.br-header');
  if (header) {
    let ticking = false;
    on(window, 'scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        header.classList.toggle('is-stuck', window.scrollY > 8);
        ticking = false;
      });
    }, { passive: true });
  }

  /* --- Lades (menu, filters, winkelwagen) ------------------------------- */
  class BrambleDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = $('#br-overlay');
      this.trap = focusTrap(this);
      on(document, 'keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      $$('[data-drawer-open="' + this.id + '"]').forEach((b) =>
        on(b, 'click', (e) => { e.preventDefault(); this.open(b); })
      );
    }
    open(trigger) {
      this.opener = trigger || this.opener;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      this.overlay && this.overlay.classList.add('is-open');
      document.body.classList.add('is-locked');
      on(this, 'keydown', this.trap);
      const first = $('[data-drawer-close]', this);
      first && first.focus();
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      this.overlay && this.overlay.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      this.removeEventListener('keydown', this.trap);
      this.opener && this.opener.focus && this.opener.focus();
    }
  }
  customElements.define('bramble-drawer', BrambleDrawer);

  const overlay = $('#br-overlay');
  on(overlay, 'click', () => $$('bramble-drawer.is-open').forEach((d) => d.close()));

  // Sluitknoppen via delegatie (overleven het herladen van de winkelwagen)
  on(document, 'click', (e) => {
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (!closeBtn) return;
    const drawer = closeBtn.closest('bramble-drawer');
    drawer && drawer.close();
  });

  /* --- Carrousel -------------------------------------------------------- */
  class BrambleRail extends HTMLElement {
    connectedCallback() {
      this.rail = $('[data-rail]', this);
      this.prev = $('[data-rail-prev]', this);
      this.next = $('[data-rail-next]', this);
      if (!this.rail) return;
      on(this.prev, 'click', () => this.scrollBy(-1));
      on(this.next, 'click', () => this.scrollBy(1));
      on(this.rail, 'scroll', () => this.sync(), { passive: true });
      this.sync();
    }
    step() {
      const card = this.rail.firstElementChild;
      return card ? card.getBoundingClientRect().width + 24 : 300;
    }
    scrollBy(dir) { this.rail.scrollBy({ left: dir * this.step(), behavior: 'smooth' }); }
    sync() {
      if (!this.prev || !this.next) return;
      const max = this.rail.scrollWidth - this.rail.clientWidth - 2;
      this.prev.disabled = this.rail.scrollLeft <= 2;
      this.next.disabled = this.rail.scrollLeft >= max;
    }
  }
  customElements.define('bramble-rail', BrambleRail);

  /* --- Productgalerij --------------------------------------------------- */
  class BrambleGallery extends HTMLElement {
    connectedCallback() {
      this.main = $('[data-gallery-main]', this);
      this.thumbs = $$('[data-gallery-thumb]', this);
      this.thumbs.forEach((t, i) => {
        on(t, 'click', () => this.show(i));
        on(t, 'keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.thumbs[(i + 1) % this.thumbs.length].focus(); }
          if (e.key === 'ArrowLeft')  { e.preventDefault(); this.thumbs[(i - 1 + this.thumbs.length) % this.thumbs.length].focus(); }
        });
      });
      on(this, 'bramble:variant', (e) => {
        const id = e.detail && e.detail.media_id;
        if (!id) return;
        const idx = this.thumbs.findIndex((t) => t.dataset.mediaId === String(id));
        if (idx > -1) this.show(idx);
      });
    }
    show(i) {
      const t = this.thumbs[i];
      if (!t || !this.main) return;
      const img = $('img', this.main);
      if (img) {
        img.src = t.dataset.full || $('img', t).src;
        img.srcset = t.dataset.srcset || '';
        img.alt = t.dataset.alt || img.alt;
      }
      this.thumbs.forEach((x, j) => x.setAttribute('aria-current', String(j === i)));
    }
  }
  customElements.define('bramble-gallery', BrambleGallery);

  /* --- Variantkiezer ---------------------------------------------------- */
  class BrambleVariants extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(($('[data-variants]', this) || {}).textContent || '[]');
      this.form = this.closest('form');
      this.idInput = $('[name="id"]', this.form || this);
      this.priceEl = $('[data-price]', document);
      this.wasEl = $('[data-price-was]', document);
      this.pctEl = $('[data-price-pct]', document);
      this.atc = $('[data-atc]', document);
      $$('input[type="radio"]', this).forEach((r) => on(r, 'change', () => this.update()));
      this.update(true);
    }
    selected() {
      const chosen = $$('input[type="radio"]:checked', this).map((r) => r.value);
      return this.data.find((v) => v.options.every((o, i) => o === chosen[i]));
    }
    update(initial) {
      const v = this.selected();
      if (!v) {
        if (this.atc) { this.atc.disabled = true; this.atc.textContent = this.atc.dataset.unavailable || 'Niet beschikbaar'; }
        return;
      }
      if (this.idInput) this.idInput.value = v.id;
      if (this.priceEl) this.priceEl.innerHTML = money(v.price);
      if (this.wasEl && this.pctEl) {
        if (v.compare && v.compare > v.price) {
          this.wasEl.textContent = money(v.compare);
          this.pctEl.textContent = '-' + Math.round((v.compare - v.price) / v.compare * 100) + '%';
          this.wasEl.hidden = false;
          this.pctEl.hidden = false;
        } else {
          this.wasEl.hidden = true;
          this.pctEl.hidden = true;
        }
      }
      if (this.atc) {
        this.atc.disabled = !v.available;
        this.atc.textContent = v.available
          ? (this.atc.dataset.add || 'In winkelwagen')
          : (this.atc.dataset.soldout || 'Uitverkocht');
      }
      if (!initial) {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
        const gallery = $('bramble-gallery');
        gallery && gallery.dispatchEvent(new CustomEvent('bramble:variant', { detail: v }));
      }
    }
  }
  customElements.define('bramble-variants', BrambleVariants);

  /* --- Personalisatie: namen graveren, aantal volgt het gekozen aantal pootjes --- */
  const perso = $('[data-perso]');
  if (perso) {
    const preview = $('[data-perso-preview]', perso);
    const nameInputs = $$('[data-perso-name]', perso);
    const rows = $$('[data-name-row]', perso);
    const fonts = $$('input[name="properties[Lettertype]"]', perso);
    const samples = $$('[data-perso-sample]', perso);
    const pawRadios = $$('[data-paw-option]');
    const hint = $('[data-perso-hint]', perso);

    const pawCount = () => {
      const c = pawRadios.find((r) => r.checked);
      const n = c ? parseInt(c.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    };
    // Toon evenveel naamvelden als er pootjes gekozen zijn; verborgen velden
    // worden uitgeschakeld zodat ze niet meesturen bij het bestellen.
    const syncRows = () => {
      const count = pawCount();
      rows.forEach((row) => {
        const n = parseInt(row.dataset.nameRow, 10);
        const input = $('input', row);
        const show = n <= count;
        row.hidden = !show;
        if (input) input.disabled = !show;
      });
      if (hint) hint.textContent = count === 1
        ? '(1 pootje = 1 naam)'
        : '(' + count + ' pootjes = ' + count + ' namen)';
    };
    const draw = () => {
      const vals = nameInputs.filter((i) => !i.disabled).map((i) => i.value.trim()).filter(Boolean);
      if (preview) preview.textContent = vals.length ? vals.join(' · ') : 'Bella';
      const first = vals[0] || 'Bella';
      samples.forEach((s) => { s.textContent = first; });
      const chosen = fonts.find((f) => f.checked);
      if (preview && chosen) preview.style.fontFamily = chosen.dataset.font || 'inherit';
    };
    nameInputs.forEach((i) => on(i, 'input', draw));
    fonts.forEach((f) => on(f, 'change', draw));
    pawRadios.forEach((r) => on(r, 'change', () => { syncRows(); draw(); }));
    syncRows();
    draw();
  }

  /* --- Meer kopen = meer korting: knop stelt het aantal in ------------- */
  const bundle = $('[data-bundle]');
  if (bundle) {
    const qtyInput = $('input[name="quantity"]');
    const opts = $$('input[name="br-bundle"]', bundle);
    opts.forEach((r) => on(r, 'change', () => {
      if (r.checked && qtyInput) {
        qtyInput.value = r.dataset.bundleQty || '1';
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }));
    // Als het aantal elders wijzigt, houd de keuzeknop in de pas.
    if (qtyInput) on(qtyInput, 'change', () => {
      const val = String(qtyInput.value);
      const match = opts.find((r) => r.dataset.bundleQty === val);
      opts.forEach((r) => { r.checked = false; });
      if (match) match.checked = true;
    });
  }

  /* --- Winkelwagen: Cart-API met sections (snel + betrouwbaar) --------- */
  const cartRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartBubble = $('[data-cart-count]');

  function swapDrawer(sections) {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#br-cart-drawer');
    const current = $('#br-cart-drawer');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      const c = current.querySelector('[data-cart-count-src]');
      if (c && cartBubble) {
        const n = parseInt(c.textContent, 10) || 0;
        cartBubble.textContent = n;
        cartBubble.hidden = n === 0;
      }
    }
  }

  // Elke actie geeft een oplopend volgnummer; alleen het nieuwste antwoord
  // wordt toegepast, zodat snel klikken de lade niet uit de bocht laat vliegen.
  let reqSeq = 0;
  async function cartChange(line, quantity) {
    const my = ++reqSeq;
    try {
      const res = await fetch(cartRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: location.pathname })
      });
      const data = await res.json();
      if (my === reqSeq) swapDrawer(data.sections);
    } catch (e) { /* stil */ }
  }

  // Aantalknoppen in de winkelwagen (delegatie)
  on(document, 'click', (e) => {
    const btn = e.target.closest('#br-cart-drawer [data-qty] button');
    if (!btn) return;
    const input = $('input', btn.closest('[data-qty]'));
    if (!input || (input.name || '').indexOf('updates') === -1) return;
    const delta = btn.dataset.qtyStep === 'up' ? 1 : -1;
    const line = parseInt(input.dataset.line, 10);
    const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    input.value = next;
    cartChange(line, next);
  });
  on(document, 'change', (e) => {
    const input = e.target.closest('#br-cart-drawer [data-qty] input');
    if (!input || (input.name || '').indexOf('updates') === -1) return;
    cartChange(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  // Toevoegen aan winkelwagen — product- én aanbevelingsformulieren (delegatie)
  on(document, 'submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    const btn = $('[data-atc]', form);
    if (!btn || btn.dataset.noAjax) return;
    e.preventDefault();
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.adding || 'Even geduld…';
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', location.pathname);
    const my = ++reqSeq;
    try {
      const res = await fetch(cartRoot() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error('cart');
      if (my === reqSeq) swapDrawer(data.sections);
      const d = $('#br-cart-drawer');
      d && d.open && d.open(btn);
      btn.textContent = btn.dataset.added || 'Toegevoegd';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
    } catch (err) {
      btn.textContent = btn.dataset.error || 'Er ging iets mis';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1600);
    }
  });

  /* --- Aantalknoppen (product-formulier, niet de winkelwagen) ----------- */
  $$('[data-qty]').forEach((wrap) => {
    const input = $('input', wrap);
    if (!input) return;
    if ((input.name || '').indexOf('updates') !== -1) return; // winkelwagen regelt zichzelf via delegatie
    $$('button', wrap).forEach((b) =>
      on(b, 'click', () => {
        const delta = b.dataset.qtyStep === 'up' ? 1 : -1;
        const next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      })
    );
  });

  /* --- Filters: auto-submit + mobiele toggle ---------------------------- */
  const facetForm = $('[data-facet-form]');
  if (facetForm) {
    let t;
    on(facetForm, 'change', () => { clearTimeout(t); t = setTimeout(() => facetForm.submit(), 350); });
  }
  const facetToggle = $('[data-facet-toggle]');
  on(facetToggle, 'click', () => {
    const panel = $('.br-facets');
    const open = panel.classList.toggle('is-open');
    facetToggle.setAttribute('aria-expanded', String(open));
  });

  /* --- Scroll reveal ----------------------------------------------------- */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('.br-reveal').forEach((el) => io.observe(el));
  } else {
    $$('.br-reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* --- Theme editor: secties opnieuw initialiseren ----------------------- */
  document.addEventListener('shopify:section:load', () => {
    $$('.br-reveal').forEach((el) => el.classList.add('is-in'));
  });
})();
